export const DevelopmentEnvironmentState = {
  showMenu: false,
  showLocationState: false,
};
